import { JobContractFilters } from './JCFilters';
import useParams from '../../../hooks/useParamsAndCookies';
import { URLParam } from '../../../Interfaces/system/params.interfaces';
import { parseDate, parseId } from '@/src/utils/param';

const params: URLParam<JobContractFilters>[] = [
  { label: 'reportType' },
  { label: 'job', isEncrypted: true },
  { label: 'contract', isEncrypted: true },
  { label: 'id' },
  { label: 'submittedID' },
  { label: 'info' },
  { label: 'jobState' },
  { label: 'contractState' },
  { label: 'startDate', parse: parseDate },
  { label: 'endDate', parse: parseDate },
  { label: 'phases', multiple: true },
  { label: 'pms', isEncrypted: true, multiple: true, parse: parseId },
  { label: 'contracts', isEncrypted: true, multiple: true },
  { label: 'extraDetails' },
];

const formatFilters = (filters: Partial<JobContractFilters>) => {
  return {
    ...filters,
    startDate: filters.startDate ? filters.startDate.toString() : null,
    endDate: filters.endDate ? filters.endDate.toString() : null,
  };
};

const JCParams = () => {
  useParams<JobContractFilters>({
    tab: 'JC',
    params,
    formatFilters,
    filterChanges: (values) => {
      const cookies = values as {
        startDate: string | null;
        endDate: string | null;
      };
      const { startDate, endDate, ...otherFields } = cookies;
      const newCookies = otherFields as Record<string, unknown>;
      if (startDate) {
        newCookies['startDate'] = new Date(startDate);
      }
      if (endDate) {
        newCookies['endDate'] = new Date(endDate);
      }

      return newCookies;
    },
    cookieFiltersName: 'filters',
  });

  return <span />;
};

export default JCParams;
